// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"c95dc396","673":"c2592ce0"}[chunkId] + ".chunk.js";
};